import API_URL from "../config";
import axios from "axios";

export const addItemApi = async (numeroArticle, desination, responsable, quantite, price, sumOfPrice, prestataire, ice) => {
    try {
        const token = sessionStorage.getItem("token")
        const id = sessionStorage.getItem("id")

        if(!token || !id)
            return false

        const formObject = {
            numeroArticle: numeroArticle,
            desination: desination,
            responsable: responsable,
            quantite: quantite,
            price: price,
            sumOfPrice: sumOfPrice,
            prestataire: prestataire,
            ice: ice,
        }

        const option = {
            headers: {
              Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.post(`${API_URL}/api/items/add/${id}`, formObject, option)
        return res.data
    }
    catch(err) {
        throw err
    }
}

export const getAllItemApi = async () => {
    try {
        const token = sessionStorage.getItem("token")
        const id = sessionStorage.getItem("id")

        if(!token || !id)
            return false

        const option = {
            headers: {
              Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/items/getAll/${id}`, option)
        return res.data
    }
    catch(err) {
        throw err
    }
}

export const updateItemApi = async (itemID, data) => {
    try {
        const token = sessionStorage.getItem("token")
        const id = sessionStorage.getItem("id")

        if(!token || !id)
            return false

        const option = {
            headers: {
              Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.put(`${API_URL}/api/items/update/${id}/${itemID}`, data, option)
        return res.data
    }
    catch(err) {
        throw err
    }
}

export const deleteItemApi = async (itemID) => {
    try {
        const token = sessionStorage.getItem("token")
        const id = sessionStorage.getItem("id")

        if(!token || !id)
            return false

        const option = {
            headers: {
              Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.delete(`${API_URL}/api/items/delete/${id}/${itemID}`, option)
        return res.data
    }
    catch(err) {
        throw err
    }
}
